import { TAGS_COLORS, VALID_TAG_COLORS } from "./constants";
import { TagColor } from "./types";

export function isValidTagColor(color: unknown): boolean {
  return typeof color === "string" && (VALID_TAG_COLORS as string[]).includes(color);
}

export function normalizeTagColor(color: unknown): TagColor {
  if (isValidTagColor(color)) {
    return color as TagColor;
  }
  // Default to blue if color is invalid
  return "blue";
}

export function getTagColorClassName(color: TagColor | null) {
  return color && isValidTagColor(color) ? TAGS_COLORS[color].fgClass : undefined;
}

export function getTagBgColorClassName(color: TagColor | null) {
  return color && isValidTagColor(color) ? TAGS_COLORS[color].bgClass : undefined;
}
